/** The base roles P0 grants, weakest first. Never `owner`: an account has one
 * owner, and P0 doesn't hand that over. */
export const LAUNCHDARKLY_BASE_ROLES = ["reader", "writer", "admin"] as const;

export type LaunchDarklyBaseRole = (typeof LAUNCHDARKLY_BASE_ROLES)[number];

/** Every base role LaunchDarkly reports on a member, weakest first. Each holds
 * every permission of the ones before it, so the order is the rank: a grant
 * only raises a member's base role, and a revoke only lowers it. */
export const LAUNCHDARKLY_MEMBER_ROLES = [
  "no_access",
  ...LAUNCHDARKLY_BASE_ROLES,
  "owner",
] as const;

export type LaunchDarklyMemberRole = (typeof LAUNCHDARKLY_MEMBER_ROLES)[number];
